import { Accordion, ButtonText } from '@morressier/alembic';
import { faArrowRotateLeft, faBell } from '@fortawesome/pro-regular-svg-icons';
import { Flex, Text } from '@chakra-ui/react';
import { IconBadge } from 'src/components/IconBadge';
import { MY_SUBMISSION_TABS } from 'src/constants';
import AdditionalInformationWrapper from '../../AdditionalInformationWrapper';

export const AuthorUnsubmittedAdditionalInfo = ({
  setActiveTab
}: {
  setActiveTab: (tab: any) => JSX.Element;
}) => (
  <AdditionalInformationWrapper>
    <Accordion
      chakraAccordionProps={{
        width: '100%',
        defaultIndex: [0],
        allowToggle: true
      }}
      items={[
        {
          title: (
            <Flex alignItems={'flex-start'} gap={2}>
              <IconBadge icon={faBell} variant="neutral" />
              <Flex flexDirection={'column'} marginLeft={2}>
                <Text textStyle="headingItem">Highlights</Text>
                <Text textStyle="textContext">
                  Review key updates and other relevant information in this
                  phase.
                </Text>
              </Flex>
            </Flex>
          ),
          content: (
            <Flex flexDirection="column" width="100%" gap={4}>
              <Flex gap={3} alignItems="start">
                <IconBadge icon={faArrowRotateLeft} variant="attention" />
                <Text textStyle="headingItem">Submission Unsubmitted</Text>
                <ButtonText
                  marginLeft="auto"
                  onClick={() => {
                    setActiveTab?.(MY_SUBMISSION_TABS.FEEDBACK);
                  }}
                >
                  View Feedback
                </ButtonText>
              </Flex>
            </Flex>
          )
        }
      ]}
    />
  </AdditionalInformationWrapper>
);
